module.exports = __webpack_public_path__ + "img/swimming.159bd310.jpg";